import { create } from 'zustand'
import { nanoid } from 'nanoid'

export type ToastVariant = 'success' | 'error' | 'warning' | 'info'

export interface Toast {
  id: string
  variant: ToastVariant
  message: string
  durationMs: number
}

interface ToastState {
  toasts: Toast[]
  show: (message: string, variant?: ToastVariant, durationMs?: number) => void
  dismiss: (id: string) => void
}

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],

  show: (message, variant = 'info', durationMs = 4000) => {
    const id = nanoid(8)
    set((s) => ({ toasts: [...s.toasts, { id, variant, message, durationMs }] }))
    setTimeout(() => {
      set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }))
    }, durationMs)
  },

  dismiss: (id) =>
    set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}))

/** Convenience helpers — call these anywhere (not inside React components) */
export const toast = {
  success: (msg: string) => useToastStore.getState().show(msg, 'success'),
  error: (msg: string) => useToastStore.getState().show(msg, 'error'),
  warning: (msg: string) => useToastStore.getState().show(msg, 'warning'),
  info: (msg: string) => useToastStore.getState().show(msg, 'info'),
}
